<template>
  <v-container class="custom-container">
    <v-row dense>
      <v-col cols="12">
        <v-card class="pa-5" elevation="0" :color="$vuetify.theme.dark ? '#131c29' : '#E0EAF2'">
          <v-row>
            <v-col cols="12" :sm="$canRoute('account-groups') !== 1 ? 12 : 10">
              <v-text-field v-model="search" prepend-icon="mdi-magnify" label="Search here ..." single-line solo
                hide-details class="custom-v-input"></v-text-field>
            </v-col>

            <v-col cols="12" sm="2" v-if="$canRoute('account-groups') === 1">
              <v-dialog transition="scale-transition" origin="center center" max-width="492" v-model="dialog2"
                content-class="deposit-withdraw-popup marketingPopup">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn large tile block elevation="0" class="ma-0 text-capitalize btn-account" color="greenMain"
                    height="48px" v-bind="attrs" v-on="on">
                    Add New
                  </v-btn>
                </template>

                <v-card class="rounded-0 pa-7" :class="$vuetify.theme.dark ? 'blue-darken-1' : 'white-lighten-5'">
                  <v-card-title class="pb-3 text-left justify-start pl-3">
                    Add New Acc. Group & Limitation
                  </v-card-title>

                  <v-card-subtitle class="mt-0 pl-3 pb-0 pr-10 text--ash">
                    You Can Add New Group Here
                  </v-card-subtitle>

                  <v-card class="deposit-form px-3 py-4"
                    :class="$vuetify.theme.dark ? 'blue-darken-1' : 'white-lighten-5'">
                    <v-row>
                      <v-col cols="12">
                        <fieldset>
                          <legend>Account Status*</legend>
                          <v-select solo :items="createIsLiveSlots" v-model="create_liveDemo" item-value="value"
                            item-text="text" append-icon="mdi-chevron-down" label="Select Status" class="custom-select"
                            hide-details></v-select>
                        </fieldset>
                      </v-col>

                      <v-col cols="12">
                        <fieldset>
                          <legend>Currency*</legend>
                          <v-select solo :items="currencies" v-model="currency_id" item-value="id"
                            item-text="currency_name" append-icon="mdi-chevron-down" label="Select Currency"
                            class="custom-select" hide-details></v-select>
                        </fieldset>
                      </v-col>

                      <v-col cols="12">
                        <fieldset>
                          <legend>Acc. Book Type*</legend>
                          <v-select solo :items="book_type" v-model="book_type_value" item-value="value"
                            item-text="value" append-icon="mdi-chevron-down" label="Select Book Type"
                            class="custom-select" hide-details></v-select>
                        </fieldset>
                      </v-col>

                      <v-col cols="12">
                        <fieldset>
                          <legend>Account Type*</legend>
                          <v-text-field v-model="create_account_type_display" label="Write Here" single-line solo
                            hide-details class="custom-select"></v-text-field>
                        </fieldset>
                      </v-col>

                      <v-col cols="12">
                        <fieldset>
                          <legend>Minimum Deposit*</legend>
                          <v-text-field type="number" v-model="create_min_deposit" label="Write Here" single-line solo
                            hide-details class="custom-select"></v-text-field>
                        </fieldset>
                      </v-col>

                      <v-col cols="12">
                        <fieldset>
                          <legend>Minimum Withdraw*</legend>
                          <v-text-field type="number" v-model="create_min_withdraw" label="Write Here" single-line solo
                            hide-details class="custom-select"></v-text-field>
                        </fieldset>
                      </v-col>

                      <v-col cols="12">
                        <fieldset>
                          <legend>Maximum Leverage*</legend>
                          <v-text-field type="number" v-model="create_max_leverage" label="Write Here" single-line solo
                            hide-details class="custom-select"></v-text-field>
                        </fieldset>
                      </v-col>

                      <v-col cols="12">
                        <fieldset>
                          <legend>MT5 Group Type*</legend>
                          <v-text-field v-model="create_account_type_real" label="Write Here" single-line solo
                            hide-details class="custom-select"></v-text-field>
                        </fieldset>
                      </v-col>

                      <v-col cols="12">
                        <fieldset>
                          <legend>Personal Max Allowance*</legend>
                          <v-text-field type="number" v-model="create_max_allowance_personal" label="Write Here"
                            single-line solo hide-details class="custom-select"></v-text-field>
                        </fieldset>
                      </v-col>

                      <v-col cols="12">
                        <fieldset>
                          <legend>Corporate Max Allowance*</legend>
                          <v-text-field type="number" v-model="create_max_allowance_corporate" label="Write Here"
                            single-line solo hide-details class="custom-select"></v-text-field>
                        </fieldset>
                      </v-col>

                      <!-- New columns -->
                      <v-col cols="12">
                        <fieldset>
                          <legend>Account Open Series*</legend>
                          <v-text-field type="number" v-model="create_account_open_series" label="Write Here"
                            placeholder="Enter account open series" single-line solo hide-details
                            class="custom-select"></v-text-field>
                        </fieldset>
                      </v-col>

                      <v-col cols="12">
                        <fieldset>
                          <legend>Account Length*</legend>
                          <v-text-field type="number" v-model="create_account_length" label="Write Here"
                            placeholder="Enter account length" single-line solo hide-details
                            class="custom-select"></v-text-field>
                        </fieldset>
                      </v-col>

                      <v-col cols="12">
                        <v-switch v-model="create_status" inset color="#039de9" :ripple="false">
                          <template v-slot:label>
                            <div>
                              <span>Visible to Client</span>
                              <div style="font-size: smaller; color: #708aa7">
                                {{ create_status ? "ON" : "OFF" }}
                              </div>
                            </div>
                          </template>
                        </v-switch>
                      </v-col>
                    </v-row>
                  </v-card>

                  <v-card-actions>
                    <v-row dense>
                      <v-col cols="12">
                        <v-btn tile @click="handleCreate" elevation="0" class="text-capitalize btn-account mr-3 px-sm-8"
                          color="greenMain">
                          Submit
                        </v-btn>

                        <v-btn tile color="#FF567F" @click="handleCreateClose" elevation="0"
                          class="text-capitalize btn-account px-sm-8">
                          Close
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-col>
          </v-row>

          <v-row dense>
            <v-col cols="12" sm="12">
              <v-card class="pa-3 rounded-0 elevation-0" :color="$vuetify.theme.dark ? '#172233' : '#E8F1F8'">
                <v-sheet class="transactionTable depositTabTable" :color="$vuetify.theme.dark ? '#1A2A3E' : '#F1F7FB'">
                  <v-data-table :headers="headers" :items="groups" :search="search" :items-per-page="10">
                    <template v-slot:item.livedemo="{ item }">
                      {{
                        {
                          0: "Demo",
                          1: "Live",
                          2: "Social Trading",
                          3: "IB",
                          4: "Prop Trading",
                          5: "Contest"
                        }[item?.is_live] || "-"
                      }}
                    </template>

                    <template v-slot:item.status="{ item }">
                      <div class="status-selection status-selection-blocked-user">
                        <v-select :disabled="$canRoute('account-groups') !== 1" solo :items="slots"
                          append-icon="mdi-chevron-down" class="custom-select" v-model="item.status"
                          item-text="statusText" item-value="status" @change="handleSelectChange(item)">
                          <template v-slot:selection="{ item }">
                            <div :class="getTextColor(item)">
                              {{ item.status === 1 ? "ON" : "OFF" }}
                            </div>
                          </template>
                        </v-select>
                      </div>
                    </template>

                    <template v-slot:item.account_type_display="{ item }">
                      <v-card-text>
                        {{ item.account_type_display + " (" + item.book_type + ")" }}
                      </v-card-text>
                    </template>

                    <template v-slot:item.details="{ item }">
                      <div class="d-flex align-center">
                        <v-dialog transition="scale-transition" origin="center center" max-width="492"
                          v-model="updateDialog[item?.id]" content-class="deposit-withdraw-popup marketingPopup">
                          <template v-slot:activator="{ on, attrs }">
                            <div class="links text-decoration-none mr-3">
                              <div v-bind="attrs" v-on="on">
                                <v-icon color="#039de9" small>
                                  mdi-pencil-outline
                                </v-icon>
                              </div>
                            </div>
                          </template>

                          <template>
                            <v-card class="rounded-0 pa-7"
                              :class="$vuetify.theme.dark ? 'blue-darken-1' : 'white-lighten-5'">
                              <v-card-title class="pb-3 text-left justify-start pl-3">
                                Update Acc. Group & Limitation
                              </v-card-title>

                              <v-card-subtitle class="mt-0 pl-3 pb-0 pr-10 text--ash">
                                You Can Update Groups Here
                              </v-card-subtitle>

                              <v-card class="deposit-form px-3 py-4"
                                :class="$vuetify.theme.dark ? 'blue-darken-1' : 'white-lighten-5'">
                                <v-row>
                                  <v-col cols="12">
                                    <fieldset>
                                      <legend>Account Status</legend>
                                      <v-select solo :items="updateIsLiveSlots" v-model="item.is_live"
                                        item-value="value" item-text="text" append-icon="mdi-chevron-down" :label="item.is_live == 0
                                            ? 'Demo'
                                            : item.is_live == 1
                                              ? 'Live'
                                              : item.is_live == 2
                                                ? 'Social Trading'
                                                : item.is_live == 3
                                                  ? 'IB'
                                                  : item.is_live == 4
                                                    ? 'Prop Trading'
                                                    : 'Contest Management'
                                          " class="custom-select" hide-details></v-select>
                                    </fieldset>
                                  </v-col>

                                  <v-col cols="12">
                                    <fieldset>
                                      <legend>Currency</legend>
                                      <v-select solo :items="currencies" v-model="item.currency_id" item-value="id"
                                        item-text="currency_name" append-icon="mdi-chevron-down" label="Select Currency"
                                        class="custom-select" hide-details></v-select>
                                    </fieldset>
                                  </v-col>

                                  <v-col cols="12">
                                    <fieldset>
                                      <legend>Acc. Book Type*</legend>
                                      <v-select solo :items="book_type" v-model="item.book_type" item-value="value"
                                        item-text="value" append-icon="mdi-chevron-down" label="Select Book Type"
                                        class="custom-select" hide-details></v-select>
                                    </fieldset>
                                  </v-col>

                                  <v-col cols="12">
                                    <fieldset>
                                      <legend>Account Type</legend>
                                      <v-text-field v-model="item.account_type_display" label="Write Here" single-line
                                        solo hide-details class="custom-select"></v-text-field>
                                    </fieldset>
                                  </v-col>

                                  <v-col cols="12">
                                    <fieldset>
                                      <legend>Minimum Deposit</legend>
                                      <v-text-field type="number" v-model="item.min_deposit" label="Write Here"
                                        single-line solo hide-details class="custom-select"></v-text-field>
                                    </fieldset>
                                  </v-col>

                                  <v-col cols="12">
                                    <fieldset>
                                      <legend>Minimum Withdraw</legend>
                                      <v-text-field type="number" v-model="item.min_withdraw" label="Write Here"
                                        single-line solo hide-details class="custom-select"></v-text-field>
                                    </fieldset>
                                  </v-col>

                                  <v-col cols="12">
                                    <fieldset>
                                      <legend>Maximum Leverage</legend>
                                      <v-text-field type="number" v-model="item.max_leverage" label="Write Here"
                                        single-line solo hide-details class="custom-select"></v-text-field>
                                    </fieldset>
                                  </v-col>

                                  <v-col cols="12">
                                    <fieldset>
                                      <legend>MT5 Group Type</legend>
                                      <v-text-field v-model="item.account_type_real" label="Write Here" single-line solo
                                        hide-details class="custom-select"></v-text-field>
                                    </fieldset>
                                  </v-col>

                                  <v-col cols="12">
                                    <fieldset>
                                      <legend>Personal Max Allowance</legend>
                                      <v-text-field type="number" v-model="item.max_allowance_personal"
                                        label="Write Here" single-line solo hide-details
                                        class="custom-select"></v-text-field>
                                    </fieldset>
                                  </v-col>

                                  <v-col cols="12">
                                    <fieldset>
                                      <legend>Corporate Max Allowance</legend>
                                      <v-text-field type="number" v-model="item.max_allowance_corporate"
                                        label="Write Here" single-line solo hide-details
                                        class="custom-select"></v-text-field>
                                    </fieldset>
                                  </v-col>

                                  <!-- New columns -->
                                  <v-col cols="12">
                                    <fieldset>
                                      <legend>Account Open Series</legend>
                                      <v-text-field type="number" v-model="item.account_open_series" label="Write Here"
                                        placeholder="Enter account open series" single-line solo hide-details
                                        class="custom-select"></v-text-field>
                                    </fieldset>
                                  </v-col>

                                  <v-col cols="12">
                                    <fieldset>
                                      <legend>Account Length</legend>
                                      <v-text-field type="number" v-model="item.account_length" label="Write Here"
                                        placeholder="Enter account length" single-line solo hide-details
                                        class="custom-select"></v-text-field>
                                    </fieldset>
                                  </v-col>

                                  <v-col cols="12">
                                    <v-switch v-model="item.status" inset color="#039de9" :ripple="false">
                                      <template v-slot:label>
                                        <div>
                                          <span>Visible to Client</span>
                                          <div style="font-size: smaller; color: #708aa7">
                                            {{
                                              item?.status === 1 || item?.status === true
                                                ? "ON"
                                                : "OFF"
                                            }}
                                          </div>
                                        </div>
                                      </template>
                                    </v-switch>
                                  </v-col>
                                </v-row>
                              </v-card>

                              <v-card-actions>
                                <v-row dense>
                                  <v-col cols="12">
                                    <v-btn tile @click="handleUpdate(item)" elevation="0"
                                      class="text-capitalize btn-account mr-3 px-sm-8" color="greenMain">
                                      Submit
                                    </v-btn>

                                    <v-btn tile color="#FF567F" @click="handleClose(item)" elevation="0"
                                      class="text-capitalize btn-account px-sm-8">
                                      Close
                                    </v-btn>
                                  </v-col>
                                </v-row>
                              </v-card-actions>
                            </v-card>
                          </template>
                        </v-dialog>

                        <v-dialog v-model="deleteAccModal[item?.id]" max-width="400" class="rounded-0">
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon color="#FF567F" small v-bind="attrs" v-on="on">
                              mdi-trash-can-outline
                            </v-icon>
                          </template>

                          <v-card rounded="0" width="400" class="auth-modal-card"
                            :color="$vuetify.theme.dark ? '#111A26' : '#ffffff'">
                            <v-card-title class="px-0 pt-0">Delete?</v-card-title>
                            <v-card-text class="px-0">Do you want to delete?</v-card-text>
                            <v-card-actions class="px-0 pb-0">
                              <v-btn class="elevation-0" :color="$vuetify.theme.dark ? '#FF567F' : '#FF567F'"
                                @click="deleteItem(item)">
                                Delete
                              </v-btn>

                              <v-btn class="elevation-0" :color="$vuetify.theme.dark ? '#111A26' : '#ffffff'" outlined
                                @click="closeAccModal(item)">
                                Cancel
                              </v-btn>
                            </v-card-actions>
                          </v-card>
                        </v-dialog>
                      </div>
                    </template>
                  </v-data-table>
                </v-sheet>
              </v-card>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { ACCGROUPS__ACTIONS } from "@/store/action-types";
import { mapActions, mapState } from "vuex";

export default {
  data() {
    return {
      search: "",
      deleteAccModal: {},
      dialog: false,
      dialog2: false,
      updateDialog: {},

      createIsLiveSlots: [
        { value: 0, text: "Demo" },
        { value: 1, text: "Live" },
        { value: 2, text: "Social Trading" },
        { value: 3, text: "IB" },
        { value: 4, text: "Prop Trading" },
        { value: 5, text: "Contest Management" },
      ],

      updateIsLiveSlots: [
        { value: 0, text: "Demo" },
        { value: 1, text: "Live" },
        { value: 2, text: "Social Trading" },
        { value: 3, text: "IB" },
        { value: 4, text: "Prop Trading" },
        { value: 5, text: "Contest Management" },
      ],

      slots: [
        { status: 1, statusText: "ON", class: "text-approved" },
        { status: 0, statusText: "OFF", class: "text-decline" },
      ],

      headers: [
        { text: "Demo/Live", value: "livedemo", align: "start" },
        { text: "Account Type", value: "account_type_display" },
        { text: "MT5 Account Type", value: "account_type_real" },
        { text: "Max. Leverage", value: "max_leverage" },
        { text: "Min. Deposit", value: "min_deposit" },
        { text: "Min. Withdrawal", value: "min_withdraw" },
        { text: "Client Visibility", value: "status" },
      ],

      create_liveDemo: "",
      create_account_type_display: "",
      create_min_deposit: "",
      create_min_withdraw: "",
      create_max_leverage: "",
      create_account_type_real: "",
      create_max_allowance_personal: "",
      create_max_allowance_corporate: "",
      create_account_open_series: "",
      create_account_length: "",
      create_status: true,

      updated_isLive: "",
      currency_id: "",
      book_type_value: "",

      book_type: [
        { id: 1, value: "A Book" },
        { id: 2, value: "B Book" },
      ],
    };
  },

  computed: {
    ...mapState("accgroups", ["groups", "currencies"]),
    ...mapState("admins", ["loggedAdmin"]),
  },

  methods: {
    ...mapActions("accgroups", [
      ACCGROUPS__ACTIONS.ACCGROUPS,
      ACCGROUPS__ACTIONS.CREATEACCGROUPS,
      ACCGROUPS__ACTIONS.DELETEACCGROUPS,
      ACCGROUPS__ACTIONS.UPDATEACCGROUPS,
      ACCGROUPS__ACTIONS.GETCURRENCIESGROUP,
    ]),

    getCurrencyName(currencyId) {
      return this.currencies.find((item) => item?.id === currencyId)?.currency_name;
    },

    closeAccModal(item) {
      this.$set(this.deleteAccModal, item.id, false);
    },

    handleClose(item) {
      this.$set(this.updateDialog, item?.id, false);
    },

    handleCreateClose() {
      this.dialog2 = false;
      this.currency_id = "";
      this.create_liveDemo = "";
      this.create_account_type_display = "";
      this.create_min_deposit = "";
      this.create_min_withdraw = "";
      this.create_max_leverage = "";
      this.create_account_type_real = "";
      this.create_max_allowance_personal = "";
      this.create_max_allowance_corporate = "";
      this.create_account_open_series = "";
      this.create_account_length = "";
      this.book_type_value = "";
      this.create_status = true;
    },

    getTextColor(item) {
      return item.class;
    },

    handleSelectChange(item) {
      const parameter = {
        id: item?.id,
        status: item?.status,
      };
      this[ACCGROUPS__ACTIONS.UPDATEACCGROUPS](parameter);
    },

    handleCreate() {
      const parameter = {
        is_live: this.create_liveDemo,
        account_type_display: this.create_account_type_display,
        account_type_real: this.create_account_type_real,
        min_deposit: this.create_min_deposit,
        min_withdraw: this.create_min_withdraw,
        max_leverage: this.create_max_leverage,
        max_allowance_personal: this.create_max_allowance_personal,
        max_allowance_corporate: this.create_max_allowance_corporate,
        account_open_series: this.create_account_open_series,
        account_length: this.create_account_length,
        currency_id: this.currency_id,
        book_type: this.book_type_value,
        status: this.create_status === true ? 1 : 0,
      };

      this[ACCGROUPS__ACTIONS.CREATEACCGROUPS](parameter);
      this.handleCreateClose();
    },

    handleUpdate(item) {
      const parameter = {
        id: item?.id,
        is_live: item?.is_live,
        currency_id: item?.currency_id,
        account_type_display: item?.account_type_display,
        min_deposit: item?.min_deposit,
        min_withdraw: item?.min_withdraw,
        max_leverage: item?.max_leverage,
        account_type_real: item?.account_type_real,
        max_allowance_personal: item?.max_allowance_personal,
        max_allowance_corporate: item?.max_allowance_corporate,
        account_open_series: item?.account_open_series,
        account_length: item?.account_length,
        book_type: item?.book_type,
        status: item?.status === 1 || item?.status === true ? 1 : 0,
      };

      this[ACCGROUPS__ACTIONS.UPDATEACCGROUPS](parameter);
      this.handleClose(item);
    },

    deleteItem(item) {
      this[ACCGROUPS__ACTIONS.DELETEACCGROUPS]({ id: item?.id });
      this.$set(this.deleteAccModal, item?.id, false);
    },
  },

  async created() {
    await this[ACCGROUPS__ACTIONS.ACCGROUPS]();
    await this[ACCGROUPS__ACTIONS.GETCURRENCIESGROUP]();

    if (this.$canRoute("account-groups") === 1) {
      this.headers.push({ text: "Action", value: "details" });
    }
  },
};
</script>